import { Button, Tooltip, mergeClasses } from "@fluentui/react-components";
import { DeleteRegular, EditRegular, LinkRegular } from "@fluentui/react-icons";
import { useStyles } from "./EditProjectIqWorkspaceDialog.styles";
import { ICustomCapabilityCardProps } from "./CustomCapabilityCard.types";

export const CustomCapabilityCard = ({
  cap,
  isSaving,
  onEditStart,
  onDeleteRequest,
}: ICustomCapabilityCardProps): JSX.Element => {
  const styles = useStyles();

  return (
    <div
      className={mergeClasses(
        styles.capabilityCard,
        cap.isEnabled !== false && styles.capabilityCardEnabled,
      )}
    >
      <div className={styles.capabilityIconWrap}>
        <LinkRegular />
      </div>
      <div className={styles.capabilityMeta}>
        <div className={styles.capabilityNameRow}>
          <span className={styles.capabilityName}>{cap.name}</span>
          <span className={styles.customCapBadge}>Custom</span>
        </div>
        {cap.description && (
          <Tooltip content={cap.description} relationship="description">
            <div className={styles.capabilityDesc}>{cap.description}</div>
          </Tooltip>
        )}
      </div>
      <div
        className={styles.capabilityCardActions}
        onClick={(e) => e.stopPropagation()}
      >
        <Button
          appearance="subtle"
          icon={<EditRegular />}
          size="small"
          onClick={onEditStart}
          disabled={isSaving}
          aria-label={`Edit ${cap.name}`}
          title={`Edit ${cap.name}`}
        />
        <Button
          appearance="subtle"
          icon={<DeleteRegular />}
          size="small"
          onClick={onDeleteRequest}
          disabled={isSaving}
          aria-label={`Delete ${cap.name}`}
          title={`Delete ${cap.name}`}
        />
      </div>
    </div>
  );
};
